import { render } from "./SymptomReportGradeView.vue?vue&type=template&id=153d0179"
import script from "./SymptomReportGradeView.vue?vue&type=script&lang=js"
export * from "./SymptomReportGradeView.vue?vue&type=script&lang=js"

import "./SymptomReportGradeView.vue?vue&type=style&index=0&id=153d0179&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__